import { add_document } from '../api/document_api';

export async function uploadDocument(beneficiary_id, file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('beneficiary_id', beneficiary_id);
    formData.append('original_name', file.name);
    await add_document(formData);
}
